import React, { useState } from "react";
import { Helmet } from "react-helmet";

export const FAQ = (props) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section id="faq" className="text-center">
      <Helmet>
        <title>Sıkça Sorulan Sorular - TR Assist</title>
        <meta name="description" content="TR Assist yol yardım hizmetleri hakkında sıkça sorulan sorular ve detaylı yanıtları. Hizmet saatleri, ücretler, kapsam alanı ve daha fazlası." />
        <meta name="keywords" content="TR Assist SSS, yol yardım SSS, ikame araç SSS, sigorta yol yardım soruları" />
        <link rel="canonical" href="https://www.trassist.com.tr/#faq" />
        
        {/* FAQ için Structured Data */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": props.data ? props.data.map(faq => ({
              "@type": "Question",
              "name": faq.question,
              "acceptedAnswer": {
                "@type": "Answer",
                "text": faq.answer
              }
            })) : []
          })}
        </script>
      </Helmet>
      
      <div className="container">
        <div className="section-title">
          <h2>Sıkça Sorulan Sorular</h2>
          <p>
            TR Assist hizmetleri hakkında merak ettiğiniz soruların yanıtları
          </p>
        </div>
        <div className="row">
          <div className="col-md-10 col-md-offset-2">
            <div className="faq-container">
              {props.data
                ? props.data.map((d, i) => (
                    <div key={`${d.question}-${i}`} className="faq-item">
                      <div 
                        className="faq-question"
                        onClick={() => toggleFAQ(i)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => e.key === 'Enter' && toggleFAQ(i)}
                        aria-expanded={activeIndex === i}
                        aria-controls={`faq-answer-${i}`}
                      >
                        <h4>{d.question}</h4>
                        <span className={`faq-icon ${activeIndex === i ? 'active' : ''}`}>
                          <i className="fa fa-plus"></i>
                        </span>
                      </div>
                      <div 
                        id={`faq-answer-${i}`}
                        className={`faq-answer ${activeIndex === i ? 'active' : ''}`}
                        aria-hidden={activeIndex !== i}
                      >
                        <p>{d.answer}</p>
                      </div>
                    </div>
                  ))
                : "loading"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}; 